<template>
    <div>
        <section class="q10__jumbotron">
            <image-with-descriptions
                class="mb-8 -mt-48"
                :options="{
                    image:
                        'pages/' +
                        currentPage.slug +
                        '/' +
                        currentPage.images.oImage1.src,
                    descriptions: [
                        {
                            text: currentPage.images.oImage1.edf,
                            position: 'bottom-right', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                    ],
                }"
            />
        </section>

        <!-- <div
            class="
                jumbotron
                bg-cover bg-center bg-norepeat
                block
                md:flex
                flex-col
                xl:flex-row
            "
            :style="{
                backgroundImage:
                    'url(' +
                    $i18n.locale +
                    '/images/pages/' +
                    currentPage.slug +
                    '/' +
                    currentPage.images.oImage1.src,
            }"
        ></div> -->
        <div class="page">
            <div class="container px-11 2xl:px-3 mb-14 m-auto">
                <title-s-chapter
                    :options="{
                        from: 'from-selective_green',
                        to: 'to-golden_sand',
                    }"
                >
                    <h1 v-html="currentPage.content.sArticleTitle.alt"></h1>
                </title-s-chapter>
                <p
                    class="font-bold text-tundora text-xl mb-5"
                    v-html="currentPage.content.sArticleDescription.text"
                ></p>

                <div class="relative mb-8">
                    <div class="relative pt-6">
                        <hotspot-richmedia
                            :options="{
                                icon: 'diaporama',
                                collection: getRichmediaByCollection(
                                    currentPage,
                                    'Continuité piscicole – Emission RCF avril 2021'
                                ),
                            }"
                            class="top-2 right-2"
                        />
                    </div>
                    <TitleParagraph
                        :options="{
                            from: 'from-selective_green',
                            to: 'to-golden_sand',
                        }"
                    >
                        <p
                            class="text-lg lg:text-xl 2xl:text-3xl font-bold"
                            v-html="currentPage.content.sSubTitleOne_Title.text"
                        ></p>
                    </TitleParagraph>
                    <p
                        class="font-bold text-tundora 2xl:text-lg"
                        v-html="currentPage.content.sSubTitleOne_Content.text"
                    ></p>
                </div>
                <div class="container-components mb-4 lg:mb-8">
                    <image-with-descriptions
                        class="eliminate-margin"
                        :options="{
                            image:
                                'pages/' +
                                currentPage.slug +
                                '/' +
                                currentPage.images.oImage2.src,
                            descriptions: [
                                {
                                    text: currentPage.images.oImage2.alt,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                                {
                                    text: currentPage.images.oImage2.text,
                                    position: 'top-left', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                            ],
                        }"
                    />
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphOne_Title.text
                                "
                            ></span>
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'top',
                                }"
                            />
                        </TitleParagraph>

                        <p
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphOne_Content.text
                            "
                        ></p>
                    </div>
                    <div class="card relative">
                       
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphTwo_Title.text
                                "
                            ></span>
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'right',
                                }"
                            />
                        </TitleParagraph>

                        <span
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphTwo_Content.text
                            "
                        >
                        </span>
                        <!-- <Dots
                            :options="{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                            }"
                        /> -->
                        <image-with-descriptions
                            class="mt-2 mb-4"
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.oImage3.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.oImage3.edf_alt,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                    {
                                        text: currentPage.images.oImage3.edf,
                                        position: 'top-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                        <image-with-descriptions
                            class="mb-4"
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.oImage4.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.oImage4.edf_alt,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                    {
                                        text: currentPage.images.oImage4.edf,
                                        position: 'top-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>
                    <div class="card">
                        <!-- <Dots
                            :options="{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                            }"
                        /> -->
                        <span
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphThree_Content.text
                            "
                        ></span>
                        <div>
                             <div class="relative">
                                <hotspot-richmedia
                                    :options="{
                                        icon: 'diaporama',
                                        collection: getRichmediaByCollection(
                                            currentPage,
                                            `Le nouveau Poutès`
                                        ),
                                    }"
                                    class="top-2 right-2"
                                />
                                <hotspot-richmedia
                                    :options="{
                                        icon: 'diaporama',
                                        collection: getRichmediaByCollection(
                                            currentPage,
                                            `Reconfiguration du barrage de Poutès (2019-2021)`
                                        ),
                                    }"
                                    class="top-16 right-2"
                                />
                            </div>
                            <image-with-descriptions
                                class="mt-2"
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage5.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage5.alt,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                        {
                                            text: currentPage.images.oImage5.text,
                                            position: 'top-left', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                        
                    </div>
                </div>

                <div class="mb-4 lg:mb-8">
                    <TitleParagraph
                        :options="{
                            from: 'from-selective_green',
                            to: 'to-golden_sand',
                        }"
                    >
                        <p
                            class="text-lg lg:text-xl 2xl:text-3xl font-bold"
                            v-html="currentPage.content.sSubTitleTwo_Title.text"
                        ></p>
                    </TitleParagraph>
                    <p
                        class="font-bold text-tundora 2xl:text-lg"
                        v-html="currentPage.content.sSubTitleTwo_Content.text"
                    ></p>
                </div>

                <div class="container-components mb-4 lg:mb-8">
                    <div class="card" style="padding-top: 0;">
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'bottom',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.sParagraphFour_Title
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <p
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphFour_Content.text
                            "
                        ></p>
                    </div>
                    <div class="card">
                        <!-- <div class="break-inside-avoid">
                            <div class="relative pt-10">
                                <hotspot-richmedia
                                    :options="{
                                        icon: 'diaporama',
                                        collection: getRichmediaByCollection(
                                            currentPage,
                                            'Lâchers morphogènes : suivez le guide !'
                                        ),
                                    }"
                                    class="top-0 xl:-top-2 right-2"
                                />
                            </div>
                        </div> -->
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphFive_Title
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <span
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphFive_Content.text
                            "
                        ></span>
                        <!-- <Square
                            :options="{
                                from: 'from-golden_sand',
                                to: 'to-sushi',
                            }"
                        /> -->
                    </div>
                </div>
                <div class="relative">
                    <image-with-descriptions
                        :options="{
                            image:
                                'pages/' +
                                currentPage.slug +
                                '/' +
                                currentPage.images.oImage6.src,
                            descriptions: [
                                {
                                    text: currentPage.images.oImage6.alt,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                                {
                                    text: currentPage.images.oImage6.text,
                                    position: 'top-left', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                            ],
                        }"
                    />
                    <hotspot-richmedia
                        :options="{
                            icon: 'diaporama',
                            collection: getRichmediaByCollection(
                                currentPage,
                                'Nessie, le “robot piscine” pour draguer les retenues'
                            ),
                        }"
                        class="top-2 right-2"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import TitleSChapter from "../../components/TitleSChapter.vue";
import Triangles from "../../components/Triangles.vue";
import TitleParagraph from "../../components/TitleParagraph.vue";
import Paragraph from "../../components/Paragraph.vue";
import ImageWithDescriptions from "../../components/ImageWithDescriptions.vue";

export default {
    components: {
        TitleSChapter,
        Triangles,
        TitleParagraph,
        ImageWithDescriptions,
        Paragraph,
    },
    name : "PageTest",
    mixins: [PagesMixin],
};
</script>

<style scoped lang='scss'>
.card {
    &.card-1 {
        // column-count: 2;
    }
}
</style>
